import { jwtDecode } from 'jwt-decode';

import { StorageUtils } from '@celum/core/util';

export function getTokenForId(id: string, newToken: string): string {
  // in case there exists no token for the id, return no token
  if (!newToken) {
    return null;
  }

  const oldToken = StorageUtils.getItem(id);
  // if there is no token in the local storage, save the new one
  if (!oldToken) {
    const claims: any = jwtDecode(newToken);
    const properties = (window as any).Celum.properties;
    let expiresAt = claims.exp;

    if (!expiresAt) {
      expiresAt = Date.now() / 1000 + properties.mockTokenDefaultExpiration * 1000;
    }
    const currentTimeStamp = Date.now();
    const tokenExpirationOffset = properties.tokenExpirationOffset;
    // throw away token earlier, such that expiration does not cause problems with downloading
    StorageUtils.setItem(id, newToken, expiresAt * 1000 - currentTimeStamp - tokenExpirationOffset * 1000);
    return newToken;
  }
  return oldToken;
}
